import type { KpiWeeklyEntry } from "../../types/kpiDashboard";

const KPI_DATA_STORAGE_KEY = "kpi_data_json";

export function storeKpiData(entries: KpiWeeklyEntry[]): boolean {
  try {
    localStorage.setItem(
      KPI_DATA_STORAGE_KEY,
      JSON.stringify({ weekly: entries, syncedAt: new Date().toLocaleString("en-GB") })
    );
    return true;
  } catch {
    return false;
  }
}

export function getKpiDataFromStorage(): { entries: KpiWeeklyEntry[]; syncedAt: string } | null {
  try {
    const stored = localStorage.getItem(KPI_DATA_STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (Array.isArray(parsed?.weekly)) {
      return { entries: parsed.weekly as KpiWeeklyEntry[], syncedAt: parsed.syncedAt ?? "" };
    }
  } catch {
    // corrupted data — remove bad payload so future loads don't hit the same failure
    localStorage.removeItem(KPI_DATA_STORAGE_KEY);
  }
  return null;
}

export function clearKpiData(): boolean {
  try {
    localStorage.removeItem(KPI_DATA_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}
